(function ($) {
  $(document).ready(function () {
    // Apply full-width class to last form-group if odd number of form groups
    $(".cta-items__gated-popup form").each(function () {
      var $formGroups = $(this).find("> .form-group");
      if ($formGroups.length % 2 === 1) {
        $formGroups.last().addClass("form-group--full-width");
      }
    });

    // Initialize Magnific Popup for gated content triggers
    $(".cta-items__gated-trigger").magnificPopup({
      type: "inline",
      closeBtnInside: true,
      callbacks: {
        open: function () {
          // Clear any previous messages when opening
          var popup = this.content;
          popup.find('[id^="message_container_"]').html("").removeClass("error");
        },
      },
    });

    function normalizeQueryValue(value) {
      if (!value) {
        return "";
      }

      return value.replace(/^['\"]|['\"]$/g, "").trim();
    }

    function scrollToElement($element) {
      if (!$element || !$element.length) {
        return;
      }

      var headerHeight = $("header").first().outerHeight() || 0;
      window.acronScrollTo($element.get(0), { offset: headerHeight + 20 });
    }

    // Check for URL parameter to trigger popup
    function checkUrlPopupTrigger() {
      var urlParams = new URLSearchParams(window.location.search);
      var popupParam = normalizeQueryValue(
        urlParams.get("popup") || urlParams.get("show-popup")
      );

      if (popupParam) {
        var $popup = null;

        // First, try to find popup by custom trigger value
        $popup = $('.cta-items__gated-popup[data-popup-trigger="' + popupParam + '"]');

        // If not found, try by index number (0, 1, 2) or full ID (cta-gated-form-0)
        if (!$popup.length) {
          var popupId = popupParam.indexOf('cta-gated-form-') === 0
            ? popupParam
            : 'cta-gated-form-' + popupParam;
          $popup = $('#' + popupId);
        }

        if ($popup.length) {
          // Get the popup ID
          var popupId = $popup.attr('id');

          // Trigger the popup
          $.magnificPopup.open({
            items: {
              src: '#' + popupId,
              type: 'inline'
            },
            closeBtnInside: true,
            callbacks: {
              open: function () {
                // Clear any previous messages when opening
                var popup = this.content;
                popup.find('[id^="message_container_"]').html("").removeClass("error");
              }
            }
          });
        }
      }
    }

    // Check for URL parameter to scroll to gated block
    function checkUrlAnchorTrigger() {
      var urlParams = new URLSearchParams(window.location.search);
      var anchorParam = normalizeQueryValue(urlParams.get("anchor"));

      if (!anchorParam) {
        return;
      }

      var $popup = $(
        '.cta-items__gated-popup[data-popup-trigger="' + anchorParam + '"]'
      );

      if ($popup.length) {
        var $targetBlock = $popup.first().prev(".cta-items__item");

        if (!$targetBlock.length) {
          $targetBlock = $popup.first().closest(".cta-items");
        }

        scrollToElement($targetBlock);
      }
    }

    // Trigger popup check after Magnific Popup is initialized
    setTimeout(checkUrlPopupTrigger, 100);
    setTimeout(checkUrlAnchorTrigger, 100);

    // Handle form submission for gated content forms
    $(document).on(
      "click",
      '.cta-items__gated-popup form input[type="button"], .cta-items__gated-popup form input[type="submit"]',
      function (e) {
        e.preventDefault();

        var $button = $(this);
        var $form = $button.closest("form");
        var $popup = $button.closest(".cta-items__gated-popup");
        var redirectUrl = $popup.data("redirect-url");
        var formIndex = $popup.attr("id").replace("cta-gated-form-", "");
        var $messageContainer = $("#message_container_" + formIndex);

        // Disable submit button
        $button.attr("disabled", "disabled");

        // Clear previous messages
        $form.find("label").removeClass("empty");
        $messageContainer.html("").removeClass("error");

        // Collect form data
        var formData = {};
        var error = 0;

        $form.find(".form_field, select").each(function () {
          var $field = $(this);
          var type = $field.attr("type");
          var name = $field.attr("name");
          var val = $field.val();

          if (type === "checkbox" || type === "radio") {
            if ($field.hasClass("required")) {
              if ($('input[type="' + type + '"]:checked', $form).length > 0) {
                if ($field.is(":checked")) {
                  formData[name] = val;
                }
              } else {
                $('label[for="' + $field.attr("id") + '"]', $form).addClass(
                  "empty"
                );
                $messageContainer.addClass("error");
                error++;
              }
            } else {
              if ($field.is(":checked")) {
                formData[name] = val;
              }
            }
          } else if (type === "hidden") {
            formData[name] = val;
          } else {
            if ($field.hasClass("required")) {
              if (val !== "" && val !== "- Select -") {
                if (name === "email" || name === "email_address") {
                  if (!isValidEmail(val)) {
                    $('label[for="' + $field.attr("id") + '"]', $form).addClass(
                      "empty"
                    );
                    $messageContainer.addClass("error");
                    error++;
                  } else {
                    formData[name] = val;
                  }
                } else {
                  formData[name] = val;
                }
              } else {
                $('label[for="' + $field.attr("id") + '"]', $form).addClass(
                  "empty"
                );
                $messageContainer.addClass("error");
                error++;
              }
            } else {
              if (name === "email" || name === "email_address") {
                if (val && !isValidEmail(val)) {
                  $('label[for="' + $field.attr("id") + '"]', $form).addClass(
                    "empty"
                  );
                  $messageContainer.addClass("error");
                  error++;
                } else {
                  formData[name] = val;
                }
              } else {
                formData[name] = val;
              }
            }
          }
        });

        // If there are errors, show message and re-enable button
        if (error > 0) {
          $messageContainer.html("Please fill in all required fields");
          $button.removeAttr("disabled");
          return;
        }

        // Submit to Zymplify
        $.ajax({
          url: "https://zymplify.com/embed/contact_process.php",
          data: { post_arr: formData },
          type: "POST",
          dataType: "json",
          crossDomain: true,
          success: function (response) {
            if (parseInt(response.SUCCESS, 10) === 1) {
              // Track the submission
              var campaign =
                parseInt($form.find('[name="campaignId"]').val(), 10) || "";
              var channel =
                parseInt($form.find('[name="channel"]').val(), 10) || "";
              var u = window.location.href;
              var ar = u.split("/");
              var domain = ar[0] + "//" + ar[2];

              makeCorsRequest(
                response.CID,
                response.CL,
                domain,
                response.E,
                campaign,
                channel
              );

              // Redirect to the link URL instead of showing thank you popup
              if (redirectUrl) {
                window.location.href = redirectUrl;
              } else {
                // Fallback: close popup and show success message
                $.magnificPopup.close();
                alert("Thank you for your submission!");
              }
            } else {
              $messageContainer.addClass("error");
              $messageContainer.html(
                "There was an error. Please try again."
              );
              $button.removeAttr("disabled");
            }
          },
          error: function () {
            $messageContainer.addClass("error");
            $messageContainer.html("There was an error. Please try again.");
            $button.removeAttr("disabled");
          },
        });
      }
    );
  });

  /**
   * Email validation
   */
  function isValidEmail(str) {
    var regex =
      /^[-_.a-z0-9]+@(([-a-z0-9]+\.)+(ad|ae|aero|af|ag|ai|al|am|an|ao|aq|ar|arpa|as|at|au|aw|az|ba|bb|bd|be|bf|bg|bh|bi|biz|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|com|coop|cr|cs|cu|cv|cx|cy|cz|de|dj|dk|dm|do|dz|ec|edu|ee|eg|eh|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gh|gi|gl|gm|gn|gov|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|in|info|int|io|iq|ir|is|it|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mil|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|museum|mv|mw|mx|my|mz|na|name|nc|ne|net|nf|ng|ni|nl|no|np|nr|nt|nu|nz|om|org|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|pro|ps|pt|pw|py|qa|re|ro|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|st|su|sv|sy|sz|tc|td|tf|tg|th|tj|tk|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|um|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|yu|za|zm|zw)|(([0-9][0-9]?|[0-1][0-9][0-9]|[2][0-4][0-9]|[2][5][0-5])\.){3}([0-9][0-9]?|[0-1][0-9][0-9]|[2][0-4][0-9]|[2][5][0-5]))$/i;
    return regex.test(str);
  }

  /**
   * CORS tracking request
   */
  function createCORSRequest(method, url) {
    var xhr = new XMLHttpRequest();
    xhr.withCredentials = true;

    if ("withCredentials" in xhr) {
      xhr.open(method, url, true);
    } else if (typeof XDomainRequest !== "undefined") {
      xhr = new XDomainRequest();
      xhr.open(method, url);
    } else {
      xhr = null;
    }

    return xhr;
  }

  function makeCorsRequest(
    contactId,
    clientId,
    origin,
    engagement,
    campaign,
    channel
  ) {
    var url =
      "https://ds360.co/track/update.php?c=" +
      contactId +
      "&id=" +
      clientId +
      "&origin=" +
      origin +
      "&e=" +
      engagement +
      "&ca=" +
      campaign +
      "&ch=" +
      channel;

    var xhr = createCORSRequest("GET", url);
    if (!xhr) {
      return;
    }

    xhr.onload = function () {};
    xhr.onerror = function () {};
    xhr.send();
  }
})(jQuery);
